<template>
  <div id="pagination-container">
    <b-pagination
      v-model="current_page"
      :total-rows="total_count"
      :per-page="page_size"
      first-number
      last-number
    >
      <template #prev-text>
        <img
          :src="require('@/assets/images/icons/arrow-icon.svg')"
          alt="vehicles"
          width="10"
          height="10"
        />
      </template>
      <template #next-text>
        <img
          :src="require('@/assets/images/icons/arrow-icon.svg')"
          style="transform: rotate(180deg)"
          alt="vehicles"
          width="10"
          height="10"
        />
      </template>
    </b-pagination>
  </div>
</template>

<script>
export default {
  emits: ["set-page"],
  props: ["active_page", "total_count", "page_size"],
  data() {
    return { current_page: this.active_page };
  },
  watch: {
    value: function (val) {
      this.current_page = val;
    },
    current_page() {
      this.$emit("set-page", this.current_page);
    },
  },
};
</script>

<style lang="scss">
.page-item .page-link {
  border: 1px solid var(--color-54) !important;
  border-radius: 8px !important;
  color: var(--color-17) !important;
  font-weight: 700 !important;
  margin-right: 5px !important;
  padding: 5px 15px !important;
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
  &:hover {
    outline: none;
    box-shadow: none;
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }
}

.page-link.active,
.active > .page-link {
  background: var(--color-23) !important;
  color: var(--color-01) !important;
}
</style>
